import { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle, ShoppingCart, ArrowLeft } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function PaymentCancelPage() {
  const { setIsOpen } = useCart();

  useEffect(() => {
    document.title = "Paiement annulé — Atelier du Mac";
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex flex-col items-center justify-center text-center px-6">
      <div className="w-20 h-20 rounded-full bg-white/5 border border-white/10 flex items-center justify-center mb-6">
        <XCircle className="w-10 h-10 text-white/30" />
      </div>
      <h1 className="text-3xl font-black text-white mb-3 tracking-tight">Paiement annulé</h1>
      <p className="text-white/50 max-w-sm mb-8">
        Votre paiement a été annulé. Votre panier est conservé — vous pouvez finaliser votre commande quand vous le souhaitez.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <button
          data-testid="cancel-reopen-cart"
          onClick={() => setIsOpen(true)}
          className="flex items-center gap-2 bg-[#FF5C00] hover:bg-[#E05200] text-white font-semibold px-6 py-3 rounded-full transition-colors"
        >
          <ShoppingCart className="w-4 h-4" /> Revoir mon panier
        </button>
        <Link
          to="/"
          data-testid="cancel-home-btn"
          className="flex items-center gap-2 border border-white/20 text-white font-semibold px-6 py-3 rounded-full hover:border-white/40 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>
      </div>
    </div>
  );
}
